// extracted by mini-css-extract-plugin
export default {"gap8":"DashboardEditViewActions-module__gap8--_01kQ"};